// workflows/delWorkflow/slice.js

import { makeDelWorkflowActions } from "./workflowsDelWorkflowactions";

export const createDelWorkflowSlice = (set, get) => ({
  delWorkflowActions: Object.freeze(makeDelWorkflowActions(set, get)),
});
